{
  "id": 2,
  "name": "solv-dev-frontend",
  "status": "ACTIVE",
  "data": {
    "recaptchaEnabled": false
  },
  "languages": {
    "en_GB": {
      "id": 1,
      "code": "en_GB",
      "name": "English (UK)"
    }
  },
  "zone": {
    "id": 1,
    "name": "Default",
    "status": "ACTIVE",
    "createdBy": 1,
    "languages": [
      "en_GB"
    ]
  },
  "configuration": {
    "name": "SOLV Energy",
    "statementType": "DIGITAL",
    "currency": "USD",
    "logo": {
      "url": "https://storage.googleapis.com/archipelago-assets/solv-energy/SOLV%20Energy%20Logo%20v2.svg"
    },
    "logoInverted": {
      "url": "https://storage.googleapis.com/archipelago-assets/solv-energy/SOLV%20Energy%20Logo%20Inverted.svg"
    },
    "heroImage": {
      "url": "https://storage.googleapis.com/archipelago-assets/solv-energy/Eland%20Solar.jpg",
      "alt": "Four men wearing high visibility vests walking toward solar panels"
    }
  }
}
